<template>
  <v-container fluid>
    <div v-if="!loading">
      <v-row class="my-2 subtitle-2 secondary--text pl-12">
        Creating a new game & teams
      </v-row>
      <v-divider />
      <v-stepper vertical v-model="e6">
        <v-stepper-step :complete="e6 > 1" step="1">
          1. Select parameters for the new game
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-container grid-list-md>
            <v-form v-model="valid" ref="form" validation>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select dense return-object v-model="set" :items="sets" item-text="item" item-value="value"
                    color="secondary" item-color="secondary" label="level of complexity" :rules="[rules.required]">
                  </v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field dense color="secondary" label="number of teams" v-model.number="teams_number"
                    name="teams_number" type="text" :rules="[rules.required, rules.max, rules.min]"
                    @change="onceMore()">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field dense color="secondary" label="number of rounds" v-model.number="rounds" name="rounds"
                    type="text" :rules="[rules.required, rules.maxRounds, rules.min]" @change="onceMore()">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field dense color="secondary" label="game description" v-model="description"
                    name="gameDescription" type="text" @change="onceMore()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-row justify="center" class="mx-2 text-pre-wrap text--error">{{error}}</v-row>
          <v-row justify="start" class=" mx-2 text-pre-wrap">{{message}}</v-row>
          <v-btn color="secondary" dark small class="text-capitalize my-2" :disabled="!valid || Boolean(error)"
            @click="createGame">Continue
          </v-btn>
          <v-btn color="secondary" dark small 
            class="text-capitalize ml-4 my-2" 
            :disabled="!valid || Boolean(error)"
            @click="() => {}">Cencel
          </v-btn>
        </v-stepper-content>

        <v-stepper-step step="2" :complete="e6 > 2">
          2. Creation {{ teams_number }} teams
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-container grid-list-md>
            <v-form>
              <v-row v-for="(team, i) in teams" :key="team.id">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field dense color="secondary" label="name of team" :value="team.name" type="text" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field dense color="secondary" label="team email" :value="`${team.name}${gameId}@gmail.com`"
                    type="text" readonly>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field dense color="secondary" label="password" :value="`${passes[i]}`" type="text" readonly>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-row justify="center" class="mx-2 error">{{ error }}</v-row>
          <v-btn color="secondary" small class="text-capitalize mr-12" :disabled="Boolean(error)">to PDF
          </v-btn>

          <v-btn color="secondary" small class="text-capitalize mr-12" :disabled="Boolean(error)"
            @click="addTeams">Continue
          </v-btn>

        </v-stepper-content>



      </v-stepper>

    </div>
    <!--!loading-->
    <div v-else class="text-center">
      <loader></loader>
    </div>
  </v-container>
</template>
 
<script>
import Loader from '../../layouts/Loader.vue';
import { PromoCodeGenerator } from '../../functions/common.js';

export default {
  data() {
    return {
      valid: false,
      message: '',
      error: '',
      e6: 1,
      rules: {
        required: value => !!value || 'required field',
        max: v => v <= 6 || 'max 6 expected',
        min: v => v >= 2 || 'min 2 expected',
        maxRounds: v => v <= 8 || 'max 8 expected',
      },
      sets: [
        { item: 'simple', value: 1 },
        { item: 'standart', value: 2 },
        { item: 'advanced', value: 3 }
      ],
      set: { item: 'standart', value: 2 },
      teams_number: 6,
      rounds: 6,
      description: '',
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    teams() {
      return this.$store.getters.teams;
    },
    newGame() {
      //console.log(this.$store.getters.newGame)
      return this.$store.getters.newGame;
    },
    trademarks() {
      return this.$store.getters.trademarks;
    },
    /* games() {
      return this.$store.getters.games;
    },*/
    gameId() {
      if (this.newGame) {
        return this.newGame.id;
      }
      return null;
    },
    passes() {
      const passwords = []
      for(let i = 0; i < this.teams.length; i++) {
        const pass = PromoCodeGenerator(6);
        passwords.push(pass)
      }
      return passwords;
    },
  },
  methods: {
    onceMore() {
      this.message = ''
      this.error = ''
    },
    async createGame() {
      if (this.$refs.form.validate()) {
        
        //create game
        const game = {
          set: this.set,
          round: 0,
          rounds: this.rounds,
          num_teams: this.teams_number,
          description: this.description,
        }
        /* console.log(game);*/
        this.addGame(game); 
        
        //get sets teams
        await this.fetchTeams();
        this.e6 = 2;
      }  
    },
    addTeams() {
      if (this.gameId) {
       //create teams
        const gameId = this.gameId;
        this.teams.map( async(t) => {
          //add products
          const products = [];         
          
          t.products.forEach(prod => {

            const tr = this.trademarks.find(brand => brand.id == prod.trademarkId);
            if (!tr) {
              throw new Error(`not found the trademark with id: ${prod.trademarkId}`)
            }
            const product = {
              productId: prod.productId,
              gameId: gameId,
              round: 0,
              trademark: tr.name,
              model: prod.model,
              material: prod.material,
              manufacturing: prod.manufacturing,
              design: prod.design,
              design_type: prod.design_type,
              variations: prod.variations,
              advanced_feature: prod.advanced_feature,
              unit_cost: prod.unit_cost,
              investments: prod.investments,
              available_from: prod.available_from,
              available_till: prod.available_till,
              sales_plan: prod.sales_plan,
              production_plan: prod.production_plan,
              retail_price: prod.retail_price,
              price: prod.price
            }
            products.push(product) 
          })
          //add channels
          const channels = [];
          t.channels.forEach(chan => {

            const channel = {
              register_round: chan.register_round,
              annual_fee: chan.annual_fee,
              entry_fee: chan.entry_fee,
              franchise_cost: chan.franchise_cost,
              franchise_fee: chan.franchise_fee,
              gameId: gameId,
              round: 0,
              name: chan.name,
              investment_costs: chan.investment_costs,
              operational_costs: chan.operational_costs,
              stores: chan.stores,
              type: chan.type,
              id: chan.id,
            }
            channels.push(channel)
          })

          //add spots
          const spots = [];

          t.spots.forEach(sp => {
            const spot = {
              gameId: gameId,
              round: 0,
              register_round: Number(sp.register_round) || 0,
              name: sp.name,
              advanced_feature: sp.advanced_feature,
              channels: sp.channels,
              design_type: sp.design_type,
              investments: sp.investments,
              objective: sp.objective,
              operations: sp.operations,
              price: sp.price,
              quality: sp.quality,
              segments: sp.segments,
              trademarkId: sp.trademarkId,
              value: sp.value,
              core_message: sp.core_message,
            }
            spots.push(spot);
          })
          
          //add resourches
          const resources = [];
          t.resources.forEach(res => {
            const resource = {
              gameId: gameId,
              round: 0,
              borrowings: res.borrowings,
              capacities: res.capacities,
              capacities_increase: res.capacities_increase,
              long_term_debt: res.long_term_debt,
              research_segments: res.research_segments,
              research_costs: res.research_costs,
            }
            resources.push(resource);
          })
          
          const team =  {
            gameId: gameId,
            name: `${t.name}_${gameId}`,
            products: products,
            channels: channels,
            spots: spots,
            resources: resources
          }
          await this.addTeam(team);
        })
        //create users
        const users = [];
        this.teams.map(async(team, i) => {
          const user = {
            name: team.name,
            email: `${team.name}${gameId}@gmail.com`,
            password: `${this.passes[i]}`
          }
          users.push(user);
        
          await this.createUser(user);          
        })
        //console.log(users)
        localStorage.setItem('users', JSON.stringify({ users }));
        this.e6 = 3;
      }
      else {
        this.error = 'game id was not found'
      }
    },
    async fetchTeams() {
      try{
        await this.$store.dispatch('fetchTeams', 
          { limit: this.teams_number, gameId: this.set.value });
      }
      catch(error) {
        this.error = `Something wrong with the gettings teams: ${error.message}`
      }
    },
    async addGame(game) {
            
      try{
        await this.$store.dispatch('createGame', game);
      }
      catch (error) {
        this.error = `Something wrong with the new game creation: ${error.message}`
      }
    },
    async createUser(user) {
      try {
        await this.$store.dispatch('addUser', user);
      }
      catch (error) {
        this.error = `Something wrong with the new user adding: ${error.message}`
      }
    },
    async addTeam(team) {
      try {
        await this.$store.dispatch('createTeam', team);
      }
      catch (error) {
        this.error = `Something wrong with the new team adding: ${error.message}`
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('fetchTrademarks');
  },
  components: { Loader }
}
</script>